import React from 'react';

function Statistics() {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='32'
			height='32'
			fill='none'
			viewBox='0 0 32 32'
		>
			<path fill='#2d2d2d' d='M28 27H5c-.55 0-1-.45-1-1V5h2v20h22v2z'></path>
			<path
				fill='#2d2d2d'
				d='M26 23h-4c-.55 0-1-.45-1-1v-8c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v8c0 .55-.45 1-1 1zm-3-2h2v-6h-2v6zM19 23h-4c-.55 0-1-.45-1-1V9c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v13c0 .55-.45 1-1 1zm-3-2h2V10h-2v11zM12 23H8c-.55 0-1-.45-1-1v-6c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v6c0 .55-.45 1-1 1zm-3-2h2v-4H9v4z'
			></path>
		</svg>
	);
}

export default Statistics;
